<h1 *ngIf="displayHeader" class="page-header">
	<i class="fa fa-exchange"></i>
	OBJECT DATA MAPPING
</h1>

<div class="infrastructure-tabs">

	<!-- ================= TAB NAVIGATION ================= -->
	<ul class="nav nav-tabs">
		<!-- DETAIL TAB FIRST -->
		<li class="active">
			<a data-toggle="tab" href="#mapping-detail-tab">
				<i class="fa fa-columns"></i>
				DATA MAPPING SET
			</a>
		</li>


	</ul>

	<!-- ================= TAB CONTENT ================= -->
	<div class="tab-content">

		<!-- ================================================= -->
		<!-- ================= DETAIL TAB =================== -->
		<!-- ================================================= -->
		<div id="mapping-detail-tab" class="tab-pane fade active in">

			<!-- ACTION BAR -->
			<div class="page-button">

				<button class="btn btn-primary" type="button" (click)="addMappingDetail()">
					<em class="fa fa-plus"></em>
					ADD DATA MAPPING
				</button>

				<div class="dropdown btn-group edgefinityHeader">
					<button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
						<em class="fa fa-th"></em> OPTIONS <span class="caret"></span>
					</button>
					<ul class="dropdown-menu">
						<li (click)="editDataMappingClicked()" [class.disabled]="!isSingleDataMappingSelected()">
							<a><em class="fa fa-pencil"></em> EDIT</a>
						</li>
						<li (click)="deleteDataMappingClicked()" [class.disabled]="!isAnyDataMappingSelected()">
							<a><em class="fa fa-remove"></em> DELETE</a>
						</li>
						<li>
							<a [routerLink]="['/data-mapping-sets/uploadfile']">
								<em class="fa fa-upload"></em> UPLOAD CSV
							</a>
						</li>
					</ul>
				</div>
				<!-- RESULTS PER PAGE -->
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
						<em class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span>
					</button>
					<ul class="dropdown-menu">
						<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClicked(value)"
							[class.active]="value === selectedPageSize">
							<a>{{ value }}</a>
						</li>
					</ul>
				</div>
			</div>

			<!-- DETAILS TABLE -->
			<table class="table table-hover">
				<thead>
					<tr>
						<th>
							<input type="checkbox" [checked]="isAllDataMappingSelected()"
								(change)="setAllDataMappingSelected($event)">
						</th>
						<th>Mapping Name</th>
						<th>Category</th>
						<th>Header / Object</th>
					</tr>
				</thead>

				<tbody>
					<ng-container *ngFor="let hdr of mappedHeaders | paginate: {
    id: 'mapping_pagination',
    itemsPerPage: selectedPageSize,
    currentPage: currentPage,
    totalItems: totalNumberOfMappings
  }">

						<tr>
							<td>
								<input type="checkbox" [(ngModel)]="hdr.selected" />
							</td>

							<td class="clickable-cell" (click)="viewMappingClicked(hdr)">
								{{ hdr.mappingName }}
							</td>
							<td>{{ hdr.objectCategory }}</td>
							<td>
								{{ hdr.objectName }}
							</td>
						</tr>
					</ng-container>
				</tbody>
			</table>
			<pagination-controls class="pagination" id="mapping_pagination" (pageChange)="pageChanged($event)"
				[directionLinks]="true" nextLabel="Next" previousLabel="Prev" [autoHide]="true">
			</pagination-controls>

		</div>



	</div>
</div>

<app-data-mapping-dtl-dialog #datamappingTypeDtlDialog [headers]="mappedHeaders" (saved)="reloadHeaders()">
</app-data-mapping-dtl-dialog>
<app-data-mapping-view-dialog #viewDialog></app-data-mapping-view-dialog>
<app-confirm-delete-dialog #confirmDeleteDialog (confirmEvent)="deleteConfirmed()">
</app-confirm-delete-dialog>
<ef-simple-success-error-dialog-box #successErrorDialog>
</ef-simple-success-error-dialog-box>